import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OriginalPayGatePaymentResponse {
  @observable
  @Type(() => Date)
  authorizedAt!: Date;

  @observable
  cardNumber!: string;

  @observable
  arn!: string;
}
